import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'vq-checkboxes-map',
  templateUrl: './form-checkboxes-map.component.html',
})
export class FormCheckboxesMapComponent implements OnInit {

  @Input('vqModel') model:Array<any>;
  @Input('vqErrors') errors:Array<string> = [];
  @Input('vqHelpText') helpText:string;
  @Input('vqOptions') options:Array<string> = [];
  @Input('vqApiService') apiService:any;
  @Input('vqLabel') label:string;
  @Output('vqModelChange') modelChange:EventEmitter<any> = new EventEmitter<any>();

  id:string;

  constructor(
    private _api:ApiService
    ) { }

  ngOnInit() {
    this._getOptions();
    // this._initModel();
  }

  public isChecked(o) {
  	return this.model[o.key];
  }

  private _isString(v) {
    return typeof v === 'string';
  }

  public getValue(o) {
    return this.model[o.key]
  }

  public change(o:any, $event) {
    this.model[o.key] = !this.model[o.key];
  	// copy model to force change detection
  	// this.model = [...this.model];
  	this.modelChange.emit(this.model);
  }

  private _getOptions() {

  }

  public hasError() {
    return (this.errors && this.errors.length > 0);
  }
}



// WEBPACK FOOTER //
// ./src/app/vqforms/form-checkboxes-map/form-checkboxes-map.component.ts